import React from 'react'
import ButtonUI from '../../widgets/action/ButtonUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import ButtonLinkUI from '../../widgets/action/ButtonLinkUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import ProjectUpdateSF from '../../components/projectapp/project/ProjectUpdateSF'
import ProjectDeleteModalSF from '../../components/projectapp/project/ProjectDeleteModalSF'

const ProjectUpdatePageUI = ({context, messageList, projectList, project,
    // delete params
    deleteMode, onDeleteClick, onCancelDeleteClick
  }) =>
  <PrivatePageSF context={context} className='pg_prj_upd' backLink='/projects'
    messageList={messageList} centered={!project}
    headerMessageKey={project && project.projectType === 'project' ? 'c_project_settings' : 'c_template_settings'}
  >
    {
      !project &&
      <SpinnerComponentUI />
    }
    {
      project &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={true} backLink='/projects' messageList={messageList}
          titleMessageKey={project.projectType === 'project' ? 'c_project_settings' : 'c_template_settings'}
        />
        <ProjectUpdateSF context={context} project={project} projectList={projectList} messageList={messageList} />

        <div className='g_m_top_100 g_flex_h'>
          <ButtonUI
            messageList={messageList}
            labelKey={project.projectType === 'project' ? 'c_delete_project' : 'c_delete_template'}
            onClick={onDeleteClick}
            transparent={true}
          />
          <ButtonLinkUI context={context} messageList={messageList}
            labelKey={project.projectType === 'project' ? 'c_project_users' : 'c_template_users'}
            to={`/projects/${project.projectId}/users`}
            transparent={true}
          />
        </div>

        <ProjectDeleteModalSF
          context={context}
          messageList={messageList}
          project={project}
          deleteMode={deleteMode}
          onCancel={onCancelDeleteClick}
        />
      </React.Fragment>
    }
  </PrivatePageSF>

export default ProjectUpdatePageUI
